<template>
  <section>
    <div class="flex">
      <ul ref="tabHeader" class="flex-1 tab-header list-reset flex no-scrollbar overflow-x-scroll">
        <li v-for="(link, index) in seoLinks"
          :key="index"
          class="mx-4 my-4 font-medium flex-none whitespace-no-wrap cursor-pointer"
          :class="{ 'selected': index === selectedIndex }"
          @click="selectedIndex = index">
          <span class="widen-click-area-10px">
            {{ link.destination }}
          </span>
        </li>
      </ul>
      <div class="flex-none my-4 ml-4">
        <button type="button" @click="scrollTabLeft">
          <svg width="24" height="24">
            <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
          </svg>
        </button>
        <button type="button" @click="scrollTabRight">
          <svg width="24" height="24">
            <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
          </svg>
        </button>
      </div>
    </div>

    <ul class="list-reset my-4">
      <li class="my-2" v-for="(product, index) in seoLinks[selectedIndex].products" :key="index">
        <a v-if="product.type === 'resorts'" :href="product.searchUrl">
          {{ seoLinks[selectedIndex].destination }} dive resorts
        </a>
        <a v-if="product.type === 'liveaboards'" :href="product.searchUrl">
          {{ seoLinks[selectedIndex].destination }} liveaboards
        </a>
        <a v-if="product.type === 'yachts'" :href="product.searchUrl">
          {{ seoLinks[selectedIndex].destination }} yachts
        </a>
        <a v-if="product.type === 'ecoventures'" :href="product.searchUrl">
          {{ seoLinks[selectedIndex].destination }} ecoventures
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data () {
    return {
      seoLinks: window.zubluSeoLinks,
      selectedIndex: 0
    }
  },
  methods: {
    scrollTabRight () {
      $(this.$refs.tabHeader)
      .animate({
        scrollLeft: this.$refs.tabHeader.scrollLeft + 200
      }, 200);
    },
    scrollTabLeft () {
      $(this.$refs.tabHeader)
      .animate({
        scrollLeft: this.$refs.tabHeader.scrollLeft - 200
      }, 200);
    }
  }
}
</script>

<style scoped>
.tab-header {
  border-bottom: 1px solid var(--border-primary);
}

.selected {
  color: var(--secondary);
  position: relative;
}

.selected::after {
  content: '';
  position: absolute;
  height: 3px;
  left: -12px;
  right: -12px;
  bottom: -16px;
  background-color: var(--secondary);
}
</style>